import { useCallback } from 'react';

import {
  TablePaginationKeyType,
  setRowsPerPage as setPersistedRowsPerPage,
} from '@brands/store/slices/tablePaginationSlice';

import { useAppDispatch, useAppSelector } from './useReduxHook';

/**
 * Reads a table's rows-per-page from the persisted tablePagination slice and
 * returns a `[value, setter]` pair, so the selection survives navigating away
 * and back. Falls back to `defaultRowsPerPage` until the user changes it.
 */
export const usePersistedRowsPerPage = (
  tableKey: TablePaginationKeyType,
  defaultRowsPerPage: number,
): [number, (value: number) => void] => {
  const dispatch = useAppDispatch();
  const rowsPerPage = useAppSelector((s) => s.tablePagination[tableKey] ?? defaultRowsPerPage);
  const setRowsPerPage = useCallback(
    (value: number) => dispatch(setPersistedRowsPerPage({ tableKey, rowsPerPage: value })),
    [dispatch, tableKey],
  );
  return [rowsPerPage, setRowsPerPage];
};
